import { jsx as _jsx } from "react/jsx-runtime";
import { Toggle } from '@base-ui/react/toggle';
import { Captions } from '@commercial-website/icons';
import React from 'react';
import { cn } from '../../utils/cn';
/**
 * Presentational captions on/off toggle for a video hero. Stateless — the caller owns the shown
 * state and the actual `<track>` control. Built on base-ui's `Toggle`, which renders a `<button>`
 * and manages the `aria-pressed` state (`packages/ui/AGENTS.md` Rule 6): "pressed" means captions
 * are showing. Icon-only to keep its footprint small over the hero (the visible caption band sits
 * beside it on narrow screens); the state label rides on `aria-label` — "Captions off" while off,
 * "Captions on" while on — so the button keeps an accessible name.
 */
export const CaptionsToggle = React.forwardRef(({ isShowing, onToggle, labels, className }, ref) => (_jsx(Toggle, { ref: ref, pressed: isShowing, onPressedChange: onToggle, "aria-label": isShowing ? labels.on : labels.off, className: cn('text-static-inverse bg-static/10 flex cursor-pointer items-center rounded-full p-2 backdrop-blur-md', className), children: _jsx(Captions, { className: cn('size-5', !isShowing && 'opacity-60') }) })));
CaptionsToggle.displayName = 'CaptionsToggle';
